import GET_ALLOTMENT from './allotment.graphql'

export default GET_ALLOTMENT
